import { Breakpoints } from "../../breakpoints.js";

if (!window.gridCarousels || !window.gridCarousels.length) { // Only run once
  window.gridCarousels = [];
  const itemClass = 'grid-carousel';

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(`.${itemClass}`).forEach((carouselItem) => {

      const swiper = carouselItem.querySelector('swiper-container');
      if (!!swiper.initialized) return;

      const maxSlides = Number(swiper.dataset.slidesPerView);

      const swiperParams = {
        breakpoints: {
          0: {
            slidesPerView: 1.25,
            spaceBetween: 20,
          },
          [Breakpoints.sm]: {
            slidesPerView: maxSlides >= 2 ? 2 : maxSlides,
            spaceBetween: 40,
          },
          [Breakpoints.md]: {
            slidesPerView: maxSlides >= 3 ? 3 : maxSlides,
          },
          [Breakpoints.xl]: {
            slidesPerView: maxSlides,
          },
        },
        navigation: {
          clickable: true,
          // disabledClass: "opacity-30 pointer-events-none",
          disabledClass: "hidden",
          nextEl: carouselItem.querySelector(`.next`),
          prevEl: carouselItem.querySelector(`.prev`),
        },
        // Hack: Inject styles into swiper.
        injectStyles: [`@media screen and (max-width: ${Breakpoints.xl}px) { :host .swiper { overflow: visible !important; } }`],
      };

      Object.assign(swiper, swiperParams);

      swiper.initialize();

      window.gridCarousels.push(swiper);
    });
  });
}
